<template>
<div class="box">
  <div>

    <div class="row mt-3">
      <div class="col-12 pb-1 border-bottom">
        <h5 class="h5-sor">密码修改 <small class="text-muted">(建议使用简单并便于输入的密码)</small></h5>
      </div>
    </div>

    <div class="row mb-3 px-1 py-1" id="buy">
      <form id="passwordForm" class="w-100 mt-3" action="/user/password" method="post">
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">新密码</label>
          <div class="col-8 p-0">
            <input type="password" class="form-control" name="password" placeholder="请输入新密码(必填)" v-model="password">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">确认新密码</label>
          <div class="col-8 p-0">
            <input type="password" class="form-control" name="repassword" placeholder="请重复输入新密码(必填)" v-model="password_sub">
          </div>
        </div>
        <button @click="edit" type="button" class="btn btn-success btn-block">立即修改</button>
        <br>

      </form>
    </div>



  </div>
  <footerPage></footerPage>
</div>
</template>

<script>
import footerPage from "@/components/userInfo/footer"
// import qs from "qs";
export default {
  name: "editPass",
  components:{footerPage},
  data(){
    return{
      password:'',
      password_sub: '',
      userData:this.$route.params,
    }
  },
  methods:{
    edit(){
      if(this.password !== this.password_sub) return this.$message('两次密码不一致')
      this.userData.pin_code = this.password_sub
      let userData = this.userData
      this.axios.post('/pass/edit',userData,this.common.configjson).then(res=>{
        if(res.data.code === 0) return this.$message({
          type:"success",
          message:"修改成功"
        })
      }).catch(()=>{
      })
    }
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }

  .account-info {
    font-size: 1rem;
  }

  .account-info > dt {
    padding-right: 0;
  }

  .container-md {
    max-width: 960px;
  }
}
::v-deep .footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>